import { Fattura } from './fattura';
import { TipoFase } from './tipologiche/tipo-fase';

export class AttivitaFattura {
  id: string;
  fattura: Fattura;
  attivita: string;
  codice: number;
  importo: any;
  tipoFase: TipoFase;
}
